import React, { Component } from "react";
import { Wrapper, Card, CardBody } from "app/NativeComponents/common";
import { CardLabel } from "app/NativeComponents/snippets";

import PromoCode from "./PromoCode";

import AddPromoCode from "./AddPromoCode";

class PromoCodes extends Component {
  render() {
    if (this.props.promo_codes.length > 0) {
      return (
        <Wrapper>
          <Card>
            <CardLabel
              title={"Promo Codes:"}
              icon={"link"}
              hasButton={false}
              onPress={() => {}}
              hasBorder={true}
            />
            {this.props.promo_codes.map(function (promo_code, i) {
              return <PromoCode key={i} promo_code={promo_code} />;
            })}
          </Card>

          <AddPromoCode {...this.props} />
        </Wrapper>
      );
    }

    return <AddPromoCode {...this.props} />;
  }
}

export default PromoCodes;
